/* eslint-disable no-console */
import jwtDecode from 'jwt-decode';

import {
  SET_CURRENT_USER,
  SET_PERMISSION,
  NOT_ENTER_USER,
  SET_USER_LOGOUT,
  NOT_FIND_USER
} from './actionTypes';

import {
  getApiInstance,
  initAuthorized,
  apiInit,
  socketInit
} from 'utils/jarvisApiClient';

import { getRequest } from 'utils/requests';
import { setUserPermissions } from 'utils/permissions';

export const login = userData => async dispatch => {
  const api = getApiInstance();
  const loginRes = await api.post('/login', userData);
  if (loginRes.status === 200) {
    const { token } = loginRes.data;
    localStorage.setItem('access_token', token);
    initAuthorized(token);
    const decoded = jwtDecode(token);
    const profileReq = await getRequest('/user/profile');
    const { permissions } = profileReq.body;
    localStorage.setItem('permissions', permissions);
    dispatch(setCurrentUser(decoded));
    dispatch(setPermissionUser(permissions));
    setUserPermissions(permissions);
    window.location.href = '/';
  }
};

export const logout = () => async dispatch => {
  const api = getApiInstance();
  await api
    .get('/logout')
    .then(() => {
      dispatch(setUserLogout());
    })
    .catch(err => {
      console.log(err);
    });
  localStorage.removeItem('access_token');
  localStorage.removeItem('permissions');
  apiInit(false);
  socketInit(false);
  dispatch(setCurrentUser({}));
  setUserPermissions([]);
  window.location.href = '/';
};

export const setPermissionUser = permissions => ({
  type: SET_PERMISSION,
  payload: permissions
});

export const setCurrentUser = user => ({
  type: SET_CURRENT_USER,
  payload: user
});

export const setNotEnterUser = () => ({
  type: NOT_ENTER_USER
});

export const setNotFindUser = () => ({
  type: NOT_FIND_USER
});

export const setUserLogout = () => ({
  type: SET_USER_LOGOUT
});
